import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { AppDeployment } from '@atlassian/mpac-types';
import merge from 'lodash/fp/mergeAll';
import { useMemo, useState } from 'react';
import { ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST, AppRequestedEvent, AppRequestFailedEvent } from '../../../../analytics/Events';
import { ANALYTICS_MODAL_STANDALONE_APP_REQUEST } from '../../../../analytics/Sources';
import { foldMarketplaceAppPaymentModel } from '../../utils';
const makeAnalyticsContextProperties = _ref => {
  let {
    currentScreen
  } = _ref;
  return _objectSpread({}, currentScreen && {
    source: currentScreen.name
  });
};
const makeAnalyticsContextAttributes = _ref2 => {
  var _appDetails$versions$, _appDetails$versions$2, _appDetails$versions$3, _appDetails$versions$4, _appDetails$versions$5, _appDetails$versions$6;
  let {
    baseData,
    requestLocation
  } = _ref2;
  const attributes = {
    requestLocation,
    category: ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST
  };
  if (!baseData.result || !baseData.result.appDetails) return attributes;
  const appDetails = baseData.result.appDetails;
  const appKey = appDetails.appKey;
  const programs = appDetails.programs;
  let paymentModel = (_appDetails$versions$ = appDetails.versions.edges) === null || _appDetails$versions$ === void 0 ? void 0 : (_appDetails$versions$2 = _appDetails$versions$[0]) === null || _appDetails$versions$2 === void 0 ? void 0 : (_appDetails$versions$3 = _appDetails$versions$2.node) === null || _appDetails$versions$3 === void 0 ? void 0 : _appDetails$versions$3.paymentModel;
  paymentModel = paymentModel && foldMarketplaceAppPaymentModel(paymentModel)(() => 'free', () => 'atlassian', () => 'vendor');
  const isEcosystemCloudApp = ((_appDetails$versions$4 = appDetails.versions.edges) === null || _appDetails$versions$4 === void 0 ? void 0 : (_appDetails$versions$5 = _appDetails$versions$4[0]) === null || _appDetails$versions$5 === void 0 ? void 0 : (_appDetails$versions$6 = _appDetails$versions$5.node) === null || _appDetails$versions$6 === void 0 ? void 0 : _appDetails$versions$6.deployment.__typename) === AppDeployment.ECOSYSTEM_CLOUD;
  let cloudAppDeployment;
  if (isEcosystemCloudApp) {
    var _appDetails$versions$7, _appDetails$versions$8, _appDetails$versions$9;
    cloudAppDeployment = (_appDetails$versions$7 = appDetails.versions.edges) === null || _appDetails$versions$7 === void 0 ? void 0 : (_appDetails$versions$8 = _appDetails$versions$7[0]) === null || _appDetails$versions$8 === void 0 ? void 0 : (_appDetails$versions$9 = _appDetails$versions$8.node) === null || _appDetails$versions$9 === void 0 ? void 0 : _appDetails$versions$9.deployment;
  }
  return _objectSpread(_objectSpread({}, attributes), {}, {
    appKey,
    paymentModel,
    programs,
    isEcosystemCloudApp: !!isEcosystemCloudApp
  }, cloudAppDeployment && {
    ecosystemCloudAppId: cloudAppDeployment.cloudAppId
  });
};
export const useAppRequestAnalytics = _ref3 => {
  let {
    baseData,
    requestLocation
  } = _ref3;
  const fireEvent = useAnalyticsEvents();
  const [currentScreen, setCurrentScreen] = useState(null);
  const analyticsContext = useMemo(() => ({
    properties: makeAnalyticsContextProperties({
      currentScreen
    }),
    attributes: makeAnalyticsContextAttributes({
      baseData,
      requestLocation
    })
  }), [baseData.pending, currentScreen, requestLocation]);
  const fireScreenEvent = function fireScreenEvent(eventType) {
    let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return fireEvent(merge([{
      eventType
    }, {
      attributes: analyticsContext.attributes
    }, payload]));
  };
  const fireTrackEvent = function fireTrackEvent(eventType) {
    let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return fireEvent(merge([{
      eventType
    }, {
      source: currentScreen,
      attributes: analyticsContext.attributes
    }, payload]));
  };
  return {
    fireEvent: {
      viewedAppRequestModalScreen: () => {
        fireScreenEvent(ANALYTICS_MODAL_STANDALONE_APP_REQUEST);
        setCurrentScreen(ANALYTICS_MODAL_STANDALONE_APP_REQUEST);
      },
      requestSucceeded: appKey => {
        fireTrackEvent(AppRequestedEvent, {
          actionSubjectId: appKey
        });
        setCurrentScreen(null);
      },
      requestFailed: (appKey, error) => {
        fireTrackEvent(AppRequestFailedEvent, {
          actionSubjectId: appKey,
          attributes: {
            errorCode: error.code,
            error: error.message,
            source: error.source
          }
        });
        setCurrentScreen(null);
      }
    },
    analyticsContext
  };
};